import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import CustomAlert from '../../components/CustomAlert';
import CustomAlerts from '../../components/CustomAlerts';
import CustomLoading from '../../components/CustomLoading';
import CustomRadioButtonGroup from '../../components/CustomRadioButtonGroup';
import { configData } from '../../config/main.config';
import { paths } from '../../config/router.config';
import wsclients from '../../services/wsclients';
import { getAddressHome, getCurrency, getOrderStatusInfo, getPackageInfo, getPackageSeleted, setDeviceInfo, setPackageInfo, setPaymentMethod } from '../../utils/commons';
import OrderProgress from '../orders/OrderProgress';
import PackageInfoView from './PackageInfoView'
import ModalONT from './ModalONT';

const CAPTURE_CARD = 'CAPTURE_CARD';
const NO_CAPTURE_CARD = 'NO_CAPTURE_CARD';

export default function PackageInfoController(props) {
    const { t } = useTranslation();
    const history = useHistory();

    const from = props.location && props.location.state && props.location.state.from ? props.location.state.from : null;
    const package_selected = getPackageSeleted() ? getPackageSeleted() : null;
    const address = getAddressHome() ? getAddressHome() : null;

    const [showLoading, setShowLoading] = useState(false);
    const [packageInfo, setPackageInfor] = useState({});
    const [physicalGoods, setPhysicalGoods] = useState(configData.physical_goods);
    const [physicalGoodSelected, setPhysicalGoodSelected] = useState();
    const [contact, setContact] = useState(null);
    const [selectedDate, setSelectedDate] = useState(package_selected && package_selected.is_recuring && package_selected.recurring_payment_date ? package_selected.recurring_payment_date : '1');
    const [selected, setSelected] = useState((package_selected && (package_selected.is_recuring || package_selected.product_type === 'vuma_core' || package_selected.product_type === 'openserve')) ? '2' : '1');
    const [options, setOptions] = useState([]);
    const [alerts, setAlerts] = useState([]);
    const [message, setMessage] = useState({});
    const [showProgressOrder, setShowProgressOrder] = useState(false);
    const [orderInfo, setOrderInfo] = useState({
        step: 0,
        status: null,
        code: null,
        message: null
    });
    const [activeStep, setActiveStep] = useState(0);
    const [showProgressLoading, setShowProgressLoading] = useState(false);
    const [showButtonClose, setShowButtonClose] = useState(false);
    const [deviceSelected, setDeviceSelected] = useState(null);
    const [storeCardOptions, setStoreCardOptions] = useState(null);
    const [storeCardSelectedOption, setStoreCardSelectedOption] = useState(CAPTURE_CARD);
    const [paymentMethodSelected, setPaymentMethodSelected] = useState('PAYGATE');
    const [loadingPrice, setLoadingPrice] = useState(false);
    const [showModalONT, setShowModalONT] = useState(false);
    const [enableCheckout, setEnableCheckout] = useState(false);
    const [isReconnect, setIsReconnect] = useState(false);
    const [ontValue, setONTValue] = useState(null);

    console.log("PackageInfoController package_selected==", package_selected);
    console.log("PackageInfoController address==", address);
    console.log("PackageInfoController from==", from);

    const dates = [
        {
            label: '1',
            value: '1',
        },
        {
            label: '16',
            value: '16',
        },
        {
            label: '21',
            value: '21',
        },
        {
            label: '26',
            value: '26',
        },
    ]

    useEffect(() => {
        onLoad();
    }, []);

    useEffect(() => {
       getProductDetail();
    },[selected])

    const onLoad = async () => {
        setShowLoading(true)
        let optionsBill = [
            {
                label: 'Prepaid 28 days non-recurring',
                value: '1',
            },
            {
                label: 'Monthly Recurring',
                value: '2',
                child: renderChild(dates),
            },
        ]
        if(package_selected && (package_selected.product_type === 'vuma_core' || package_selected.product_type === 'openserve' || package_selected.product_type === 'octotel'|| package_selected.product_type === 'metrofibre')){
            optionsBill = [
                {
                    label: 'Monthly Recurring',
                    value: '2',
                    child: renderChild(dates),
                },
            ];
            setSelected('2');
            setPackageInfor(package_selected);
            setEnableCheckout(true)
        }
        setOptions(optionsBill);
        console.log('package_selected = ', package_selected);
        // if (package_selected) 
        //     setPackageInfor(package_selected);
        // if (from === paths.package_contact) await onLoadContact();
        if(package_selected && package_selected.devices && package_selected.devices.length === 1) 
            setDeviceSelected(package_selected.devices[0]);
        
        let storeCardOptions = [
            {
                label: 'Yes',
                value: CAPTURE_CARD,
            },
            {
                label: 'No',
                value: NO_CAPTURE_CARD,
            },
        ]
        
        setStoreCardOptions(storeCardOptions);

        if (package_selected && package_selected.product_type_code == 'OC') {
            await checkONTOfLines();
        }
        setShowLoading(false)
    }

    const getProductDetail = async () => {
        if (package_selected && package_selected.product_type != 'vuma_reach') return false;
        setLoadingPrice(true)
        try {
            let _product = {
                ...packageInfo, 
                image_url: package_selected && package_selected.image_url, 
                product_type: package_selected.product_type,
                product_type_code: package_selected && package_selected.product_type_code,
                code: package_selected && package_selected.code,
            }
            let isGetDetail = true;
            if (packageInfo) {
                if (packageInfo.price_o && packageInfo.price_r) isGetDetail = false
            }
            // if (isGetDetail) {
                var result = await wsclients.lab4services.getDetailProduct(package_selected.code, selected && selected === '1' ? false : true);
                console.log("result getDetailProduct===", result);
                if (result.code == 'OK' && result.data) {
                    _product = { ..._product, ...result.data };
                    if (result.data.pricing && result.data.pricing.price) {
                        if (selected == '1') _product.price_o = result.data.pricing.price
                        else _product.price_r = result.data.pricing.price
                    }
                    setPackageInfor(_product)
                }
            // }
        } catch (error) {
            console.log("AAAA getProductDetail error: ", error)
        }
        setEnableCheckout(true)
        setLoadingPrice(false)
    }

    const checkONTOfLines = async () => {
        let address = getAddressHome();
        try {
            let result = await wsclients.lab4services.checkONTOfLines({
                lat: address && address.latitude,
                lng: address && address.longitude,
                uuid: address && address.premisesid,
            });
            //FAKE DATA
            // result = {
            //     data: {
            //         line_reconnect: true,
            //     }
            // }
            // debugger;
            console.log("AAAA checkONTOfLines result: ", result);
            if (result.data && result.data.line_reconnect) {
                //existing line show ONT 
                setShowModalONT(true)
            } else {
                setShowModalONT(false)
                //continue new register
                setEnableCheckout(true)
            }
        } catch (error) {
            console.log("AAAA checkONTOfLines error: ", error);
        }
    }

    const renderChild = (items) => {
        return (
            <div style={{ marginLeft: 20 }}>
                {items && items.length > 0 &&
                    <CustomRadioButtonGroup
                        items={items}
                        selected={selectedDate ? selectedDate : null}
                        onChange={onChangeDate}
                    />
                }
            </div>
        );
    }

    const onChangeDate = (e) => {
        setSelectedDate(e.target.value);
    }

    const onLoadContact = async () => {
        let contact_info = null;
        try {
            var result = await wsclients.contacts.getContact();
            console.log("getContact result ===", result);
            if (result.code === 'OK') {
                contact_info = result.data;
                console.log("contact_info ===", result.data);
                await setContact(contact_info);
                await onLoadPhone();
                await getContactDemographics();
            }
        } catch (ex) {
            console.log("onLoadContact exception===", ex);
        }
        return contact_info;
    }

    const onLoadPhone = async () => {
        try {
            var phoneResult = await wsclients.contacts.getPhones();
            if (phoneResult.code === 'OK') {
                var content = phoneResult.data.content;
                if (content && content.length > 0) {
                    var phone = content.filter(p => p.is_primary);
                    if (phone && phone.length > 0) {
                        console.log(' set profile_phone=== ', phone[0])
                        setContact(prevState => ({
                            ...prevState,
                            phone: phone[0],
                        }));
                    }
                }
            }
        } catch (ex) {
            console.log("onLoadPhone exception===", ex);
        }
    }

    const getContactDemographics = async () => {
        try {
            var demographicsResult = await wsclients.contacts.getContactDemographics();
            console.log('demographicsResult onLoadProfile result=', demographicsResult)
            if (demographicsResult.code === 'OK') {
                //    setContact({
                //        ...contact,
                //        ...demographicsResult.data,
                //    });
                setContact(prevState => ({
                    ...prevState,
                    graphics: demographicsResult.data
                }));
            }
        } catch (ex) {
            console.log("getContactDemographics exception===", ex);
        }
    }

    const onChangeOption = (e) => {
        setSelected(e.target.value);
    }

    const onChangeStoreCardOption = (e) => {
        setStoreCardSelectedOption(e.target.value);
    }

    const onCheckOut = async () => {
        setShowLoading(true);
        try{
            setPaymentMethod(paymentMethodSelected)
            if(packageInfo && packageInfo.product_type === 'vuma_reach'){
                var result = await wsclients.lab4services.getDetailProduct(packageInfo && packageInfo.code ? packageInfo.code : null, selected && selected === '1' ? false : true);
                console.log("result getDetailProduct===", result);
                if(result.code === 'OK'){
                    let newPackageInfo = result.data;
                    if(newPackageInfo && newPackageInfo.id){
                        newPackageInfo.product_type = 'vuma_reach';
                        newPackageInfo.is_recuring = selected && selected === '1' ? false : true;
                        newPackageInfo.recurring_payment_date = selected && selected === '2' && selectedDate ? selectedDate : null;
                        newPackageInfo.store_card = storeCardSelectedOption;
                        // if (selected && selected == '1') {
                        //     newPackageInfo.price = packageInfo.price_o ? packageInfo.price_o : packageInfo.price;
                        // } else if (selected && selected == '2') {
                        //     newPackageInfo.price = packageInfo.price_r ? packageInfo.price_r : packageInfo.price;
                        // }
                        await setPackageInfo(newPackageInfo);
                        setShowLoading(false);
                        // if (from === paths.package_contact) {
                        //     await onReOrder();
                        // } else {
                        //     props.history.push(paths.register);
                        // }
                        props.history.push(paths.register);
                    }else{
                        onShowMessage({show: true, content: t('Product not found.')});
                        return false;
                    }
                }else{
                    onShowMessage({show: true, content: t('Get Detail product failed')})
                }
            }
            else {
                let isValidDevice = onValidateDevice();
                console.log("toan test 1",packageInfo)
                if(isValidDevice){
                    console.log("toan test 2")
                    let newPackageInfo = packageInfo;
                    newPackageInfo.is_recuring = true;
                    newPackageInfo.recurring_payment_date = selectedDate ? selectedDate : null;
                    newPackageInfo.store_card = storeCardSelectedOption;
                    if (isReconnect) newPackageInfo.reconnect = 1;
                    if (ontValue) {
                        newPackageInfo.ont = ontValue.ont;
                        newPackageInfo.line_uuid = ontValue.line_uuid;
                    }
                    setPackageInfo(newPackageInfo);
                    if(deviceSelected) setDeviceInfo(deviceSelected);
                   
                    // if (from === paths.package_contact) {
                    //     await onReOrder();
                    // } else {
                    //     props.history.push(paths.register);
                    // }
                    props.history.push(paths.register);
                }
            }
        }catch(ex){
            console.log("getDetailProduct exception===", ex);
        }
        setShowLoading(false)
    }

    const onReOrder = async () => {
        setShowLoading(true);
        try {
            console.log("contact===", contact);
            // const orderStatusInfo = getOrderStatusInfo();
            setShowProgressOrder(true);
            await onCreateOrderVumatel(contact);
        } catch (ex) {
            console.log("onCreateOrder exception===", ex);
        }
        setShowLoading(false);
        setShowButtonClose(true);
    }

    const onCreateOrderVumatel = async (contact_info) => {
        console.log("contact_info===", contact_info)
        try {
            const packageInfo = getPackageInfo() ? getPackageInfo() : null;
            let body = {
                contact_id: contact_info.id,
                product_id: packageInfo && packageInfo.id ? packageInfo.id : null,
                first_name: contact_info.first_name,
                last_name: contact_info.last_name,
                phone_number: contact_info.phone && contact_info.phone.number ? contact_info.phone.number : null,
                email: contact_info.email,
                location_reference: address && address.premise_ref_isp ? address.premise_ref_isp : null,
                // location_reference: 4417892110,
                product_reference: packageInfo && packageInfo.sku ? packageInfo.sku : null,
                payment_redirect_url: window.location.origin + paths.reorders_result,
                is_recuring: packageInfo && packageInfo.family && packageInfo.family.name === 'Non-recurring service' ? false : true,
                recurring_payment_date: packageInfo && packageInfo.family && packageInfo.family.name === 'Non-recurring service' ? null : (selectedDate ? selectedDate : null),
                identity_number: contact_info.graphics && contact_info.graphics.id_details && contact_info.graphics.id_details.id_number ? contact_info.graphics.id_details.id_number : null,
            };
            console.log("body reorder vumatel===", body);
            var result = await wsclients.lab4services.reOrderVumatel(body);
            console.log("result make order===", result);
            if (result.code === 'OK') {
                let isSuccess = await onUpdateAddressContact();
                if(isSuccess){
                    setActiveStep(1);
                    setOrderInfo({
                        step: 1,
                        status: 'COMPLETED_CREATE_ORDER_VUMATEL',
                        message: t('CREATE_ORDER_SUCCESS')
                    });
                    await onCreateOrderCMR(contact_info, result.data);
                }else{
                    setOrderInfo({
                        step: 0,
                        status: 'ERROR',
                        message: t('Update address of contact failed!')
                    });
                    setShowButtonClose(true);
                }
            } else if (result.code === 'CREATE_ACTIVITY_EXCEPTION') {
                // onShowMessage({ show: true, content: t('CREATE_ACTIVITY_EXCEPTION') })
                setOrderInfo({
                    step: 0,
                    status: 'ERROR',
                    message: t('CREATE_ACTIVITY_EXCEPTION')
                });
                setShowButtonClose(true);
            } else if(result.code === 'VUMATEL_SERVER_ERROR'){
                setOrderInfo({
                    step: 0,
                    status: 'ERROR',
                    message: t('VUMATEL_SERVER_ERROR')
                });
                setShowButtonClose(true);
            }
            else {
                let entityError = result.data.error && result.data.error.entity ? JSON.parse(result.data.error.entity) : null;
                setOrderInfo({
                    step: 0,
                    status: 'ERROR',
                    message: entityError && entityError.detail && typeof(entityError.detail) === 'string' ? entityError.detail : t('SERVER_ERROR')
                });
                setShowButtonClose(true);
                // onShowMessage({ show: true, content: t('CREATE_ORDER_NOT_SUCCESS') })
            }
        } catch (ex) {
            console.log("onCreateOrder exception===", ex);
            setOrderInfo({
                step: 0,
                status: 'ERROR',
                message: t('CREATE_ORDER_NOT_SUCCESS')
            });
            setShowButtonClose(true);
        }
    }

    const onUpdateAddressContact = async () => {
        let isSuccess = false;
        try{
            if(address){
                let body = {
                    address_line_1: address.street_number + ", " + address.street_name,
                    address_line_2: address && address.suburb ? address.suburb : null,
                    state_province_county: address && address.state_province_county ? address.state_province_county : null,
                    town_city: address.town_city,
                    postal_code: address.postal_code,
                    lat: address && address.latitude ? address.latitude : null,
                    lon: address && address.longitude ? address.longitude : null,
                    vumatel_premise_id: address && address.premisesid ? address.premisesid : null,
                };
                let result = await wsclients.lab4services.onUpdateAddressContact(body);
                console.log("result update address contact===", result);
                if(result.code === 'OK'){
                    isSuccess = true;
                }else {
                    isSuccess = false;
                }
            }else{
                console.log("Not found address");
            }
        }
        catch(ex){
            console.log("onUpdateAddress exception===", ex);
        }
        return isSuccess;
    }

    const onCreateOrderCMR = async (contact_info, order_vumatel_result) => {
        try {
            const packageInfo = getPackageInfo() ? getPackageInfo() : null;
            let body = {
                contact_id: contact_info.id,
                product_id: packageInfo && packageInfo.id ? packageInfo.id : null,
                vumatel_order_id: order_vumatel_result.orderreference,
            }
            console.log("reorder body crm====", body)
            var result = await wsclients.lab4services.makeOrderCRM(body);
            console.log("result make order on CRM5===", result);
            if (result.code === 'OK') {
                setOrderInfo({ status: 'COMPLETED' })
                setActiveStep(2);
                setOrderInfo({
                    step: 2,
                    status: 'COMPLETED',
                    message: t('CREATE_ORDER_SUCCESS')
                });
                await wait(2000);
                setShowProgressOrder(false);
                onShowMessage({show: true, content: t('wait_to_redirect_payment')});
                window.location.href = order_vumatel_result.payment_url;
                // onShowMessage({ show: true, content: t('CREATE_ORDER_SUCCESS'), action: () => { history.push(paths.home) } })
            } else if (result.code === 'CREATE_ACTIVITY_EXCEPTION') {
                setOrderInfo({
                    step: 1,
                    status: 'ERROR',
                    message: t('CREATE_ACTIVITY_EXCEPTION')
                });
                setShowButtonClose(true);
            } else {
                setOrderInfo({
                    step: 1,
                    status: 'ERROR',
                    message: t('CREATE_ORDER_NOT_SUCCESS')
                });
                setShowButtonClose(true);
            }
        } catch (ex) {
            console.log("makeOrderCRM exception===", ex);
            setOrderInfo({
                step: 1,
                status: 'ERROR',
                message: t('CREATE_ORDER_NOT_SUCCESS')
            });
            setShowButtonClose(true);
        }
    }

    const onSelectDevice = (event) => {
        console.log('event:', event)
        console.log('item:', event.target)
        console.log('item:', event.target.value)
        setPhysicalGoodSelected(event.target.value)
    }

    const onShowMessage = (message) => {
        setShowLoading(false)
        setMessage(message)
    }

    const onCloseProgressOrder = () => {
        setShowProgressOrder(false);
        setOrderInfo({
            step: 0,
            status: null,
            message: null
        });
    }

    function getSteps(t) {
        return [t('order_vumatel'), t('completed_order')];
    }

    const onGoBack = () => {
        // if(from === paths.package_contact)
        //     history.push(paths.package_contact)
        // else history.push(paths.landing_page)
        // history.push(paths.landing_page)
        window.location.href = `${window.location.origin}${paths.landing_page}`
    }

    const onValidateDevice = () => {
        if(packageInfo && packageInfo.devices && packageInfo.devices.length > 0){
            if(deviceSelected) return true;
            else {
                onShowMessage({
                    show: true,
                    content: t('please_select_device'),
                });
                return false;
            }
        } 
        return true;
    }

    const onChangeDevice = (item) => {
        if(item){
            setDeviceSelected(item);
        } else {
            onShowMessage({
                show: true,
                content: t('please_select_device'),
            });
            return false;
        }
    }

    const onCloseModalONT = (ont_value) => {
        setShowModalONT(false)
        setIsReconnect(true)
        setONTValue(ont_value)
    }

    const wait = m => new Promise(r => setTimeout(r, m))

    console.log("contact_info 11111 ===", contact);
    console.log("showModalONT 11111 ===", showModalONT);
    return (
        <>
            <PackageInfoView
                currency={getCurrency()}
                from={from}
                options={options}
                selected={selected}
                packageInfo={packageInfo}
                physicalGoods={physicalGoods}
                physicalGoodSelected={physicalGoodSelected}
                deviceSelected={deviceSelected}
                loadingPrice={loadingPrice}
                onCheckOut={onCheckOut}
                onSelectDevice={onSelectDevice}
                onChangeOption={onChangeOption}
                onGoBack={onGoBack}
                onChangeDevice={onChangeDevice}
                storeCardOptions={storeCardOptions}
                onChangeStoreCardOption={onChangeStoreCardOption}
                storeCardSelectedOption={storeCardSelectedOption}
                paymentMethodSelected={paymentMethodSelected}
                setPaymentMethodSelected={setPaymentMethodSelected}
                enableCheckout={enableCheckout}
            />
            {alerts && alerts.length > 0 && <CustomAlerts alerts={alerts} />}
            {message.show && <CustomAlert
                open={message.show}
                message={message.content}
                showButtonClose={true}
                onClose={message.action ? message.action : () => onShowMessage({})}
            />}
            {showLoading && <CustomLoading open={showLoading} />}
            {showProgressOrder && <OrderProgress
                open={showProgressOrder}
                t={t}
                orderInfo={orderInfo}
                steps={getSteps(t)}
                activeStep={activeStep}
                showButtonClose={showButtonClose}
                showProgressLoading={showProgressLoading}
                onClose={() => onCloseProgressOrder()}
            />}
            {showModalONT && <ModalONT 
                open={showModalONT}
                confirmAction={onCloseModalONT}
                setEnableCheckout={setEnableCheckout}
                onClose={() => setShowModalONT(false)}
            />}
        </>
    )
}
